"use strict";
(function() {

  // Toolbox v2

  const config = (function() {
    var isDebug = document.cookie.indexOf("debugTimestamp=1") !== -1;

    var m = ($("link[href*=frontend_master]").attr("href") || "").match(/^(.+)\/user\/temp\/.+$/),
      cdnPath = m ? m[1] : "";

    return {
      cdnPath,
      snippetPath: cdnPath + "/user/documents/upload/snippets/",
      cacheBusterParam: "v",
      cacheBuster: null,
      cacheLifetime: 5 * 60000,
      noCache: isDebug,
      tabletSlickBreakpoint: shoptet.config.breakpoints.lg,
      mobileSlickBreakpoint: shoptet.config.breakpoints.sm,
    };
  })();

  const common = (function() {
    function constant(val) {
      return function() {
        return val;
      };
    }

    function identity(val) {
      return val;
    }

    function property(key) {
      return function(obj) {
        return obj[key];
      };
    }

    function matcher(key, value) {
      if(typeof key !== "object")
        return function(obj) {
          return obj[key] === value;
        };

      return function(obj) {
        for(let k in key)
          if(obj[k] !== key[k])
            return false;
        return true;
      };
    }

    function find(arr, predicate) {
      for(let i = 0; i < arr.length; i++)
        if(predicate(arr[i], i))
          return arr[i];
      return null;
    }

    function findIndex(arr, predicate) {
      for(let i = 0; i < arr.length; i++)
        if(predicate(arr[i], i))
          return i;
      return -1;
    }

    function indexBy(arr, iteratee) {
      var obj = {};
      for(let i = 0; i < arr.length; i++)
        obj[iteratee(arr[i], i)] = arr[i];
      return obj;
    }

    function groupBy(arr, iteratee) {
      const obj = {};
      for(let i = 0; i < arr.length; i++) {
        const key = iteratee(arr[i], i);
        if(!obj[key]) obj[key] = [];
        obj[key].push(arr[i]);
      }
      return obj;
    }

    function isObject(obj) {
      const type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }

    function isPlainObject(obj) {
      if(!isObject(obj))
        return false;
      const proto = Object.getPrototypeOf(obj);
      return proto === null || proto === Object.prototype;
    }

    function isString(obj) {
      return Object.prototype.toString.call(obj) === "[object String]";
    }

    function iteratee$(fn, context) {
      return function() {
        const res = fn.apply(context !== undefined ? context : this, [$(this), ...arguments]);
        return (res instanceof $) ? res.get() : res;
      };
    }

    function assignDeep(targetObj) {
      for(let i = 1; i < arguments.length; i++) {
        const sourceObj = arguments[i];

        for(let key in sourceObj) {
          const value = sourceObj[key];
          if(isPlainObject(targetObj[key])) {
            if(!isPlainObject(value))
              throw new Error("Cannot extend plain object with value of different type.");
            assignDeep(targetObj[key], value);
          } else
            targetObj[key] = value;
        }
      }
      return targetObj;
    }

    function parseNumber(str) {
      return parseFloat(("" + str).replace(/\s+/g, "").replace(",", "."));
    }

    function parsePrice(str) {
      return parseNumber(("" + str).replace(shoptet.config.currencySymbol, "").replace(/(od|ab)\s/, ""));
    }

    function pluralize(n, form1, form24, formMore) {
      n = Math.abs(n);
      return n === 1 ? form1 : (n >= 2 && n <= 4) ? form24 : formMore;
    }

    function slugify(str) {
      const letters = str.trim()
        .toLowerCase()
        .split(""); // Split to array of letters

      const transFrom = "ěščřžýáíéďťóúůňďť";
      const transTo = "escrzyaiedtouundt";
      for(let index, j = 0; j < letters.length; j++) {
        if((index = transFrom.indexOf(letters[j])) !== -1)
          letters[j] = transTo[index];
      }

      return letters
        .join("")
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-+/g, '-');
    }

    function getProperty(obj, path) {
      return path.split(".").reduce(function(cur, key) {
        if(cur === undefined)
          return cur;
        return cur[key];
      }, obj);
    }

    function setProperty(obj, path, value) {
      var parts = path.split("."),
        key;
      while(key = parts.shift()) {
        if(!parts.length) // key is last
          obj[key] = value;
        else
          obj = obj[key];
      }
    }

    function once(fn) {
      var done = false;
      return function() {
        if(done)
          return;
        done = true;
        return fn.apply(this, arguments);
      };
    }

    function debounce(func, wait) {
      var timeout;
      return function() {
        var args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          func.apply({}, args);
        }, wait);
      };
    }

    function throttle(func, wait) {
      var lastCall = 0, lastResult;

      return function() {
        var now = Date.now();
        if(now - lastCall < wait)
          return lastResult;
        lastCall = now;
        return lastResult = func.apply({}, arguments);
      };
    }

    function promiseTry(f) {
      try {
        return Promise.resolve(f());
      } catch(err) {
        return Promise.reject(err);
      }
    }

    function memoize(cacheKeyResolver, callback, storage = window.sessionStorage) {
      function resolveKey(resolver, args, context) {
        let resolvedKey;
        if(typeof resolver === "function")
          resolvedKey = resolver.apply(context, args);
        else
          resolvedKey = resolver;

        if(Array.isArray(resolvedKey))
          resolvedKey = resolvedKey.map(resolver => resolveKey(resolver, args, context)).join(".");
        else if(!isString(resolvedKey))
          resolvedKey = JSON.stringify(resolvedKey);
        else
          resolvedKey = "" + resolvedKey;

        return resolvedKey;
      }

      const pendingPromises = Object.create({});
      return function(...args) {
        const context = this;
        const cacheKey = resolveKey(cacheKeyResolver, arguments, this);
        if(pendingPromises[cacheKey])
          return pendingPromises[cacheKey];
        let cachedValue = storage?.getItem(cacheKey);
        if(!config.noCache && cachedValue != null) {
          cachedValue = JSON.parse(cachedValue);
          if(cachedValue && cachedValue.t && Date.now() <= cachedValue.t + config.cacheLifetime)
            return Promise.resolve(cachedValue.v);
        }

        const promise = promiseTry(() => callback.apply(context, args)).then(function(result) {
          try {
            if(!config.noCache && cacheKey && storage)
              storage.setItem(cacheKey, JSON.stringify({ v: result, t: Date.now() }));
          } catch(err) {
            console.error("Unable to write cache key '" + cacheKey + "':", err);
          }

          return result;
        });

        pendingPromises[cacheKey] = promise;
        return promise;
      };
    }

    return {
      constant, identity, property, matcher, isPlainObject, isString,
      find, findIndex, indexBy, groupBy, iteratee$, assignDeep,
      parseNumber, parsePrice,
      pluralize, slugify,
      getProperty, setProperty,
      once, throttle, debounce,
      promiseTry, memoize,
    };
  })();

  const helpers = (function() {
    function getLocaleKey() {
      const dl = getShoptetDataLayer();
      return dl ? dl.language + "." + dl.currency : "";
    }

    function getStrings(moduleConfig) {
      const supportedLangs = Object.keys(moduleConfig.trans || {});
      if(!supportedLangs.length)
        throw new Error("No languages available (config.trans mising or empty)");
      if(supportedLangs.length > 1 && !moduleConfig.fallbackLang)
        throw new Error("config.fallbackLang is not set, but multiple languages are available.");
      const fallbackLang = moduleConfig.fallbackLang || supportedLangs[0];
      const dl = getShoptetDataLayer();
      const lang = dl ? dl.language : fallbackLang;
      return moduleConfig.trans[lang] || moduleConfig.trans[fallbackLang] || {};
    }

    function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }

    let idCounter = 0;
    function uniqueId(prefix) {
      const id = String(++idCounter);
      return prefix ? prefix + id : id;
    }

    function classNames(...classNames) {
      return classNames.flat(Infinity).filter(Boolean).join(" ");
    }

    return { getLocaleKey, getStrings, uniqueId, uuidv4, classNames };
  })();

  const dom = (function() {
    function trimHtml($el) {
      $el = $($el);
      return $el.each(function() {
        $(this).html($(this).html().trim());
      });
    }

    function getTextShallow($el, noJoin) {
      $el = $($el);

      var parts = [];
      $el.contents().each(function() {
        if(this.nodeType === Node.TEXT_NODE)
          parts.push(this.data);
      });
      return noJoin ? parts : parts.join("");
    }

    function oneTime($el, key) {
      $el = $($el);
      key = "oneTime." + (key || "");
      if(!$el.length || $el.data(key))
        return false;
      $el.data(key, true);
      return true;
    }

    // return true only once if the contents of the given $el didn't change
    function oneTimeContents($el, key) {
      $el = $($el);
      key = "oneTimeContents." + (key || "");
      if(!$el.length)
        return false;
      for(let node of $el[0].childNodes) {
        if(node.nodeType === Node.COMMENT_NODE && node.textContent === key)
          return false;
      }
      $el.append(new Comment(key));
      return true;
    }

    function createModuleInitializer(options) {
      if(typeof options === "function")
        options = { domReady: options }; // compat
      return common.once(function init(throwInitErrors) {
        try {
          for(let dep of(options.dependencies || []))
            dep.init ? dep.init(true) : dep();
          if(options.earlyInit && options.earlyInit() === false)
            return;
          if(options.domReady)
            $(() => options.domReady());
          if(options.earlyRender)
            hooks.hookAfterDomLoad(options.earlyRender, true);
          if(options.render)
            hooks.hookAfterDomLoad(options.render, true);
          if(options.earlyRender)
            options.earlyRender();
        } catch(err) {
          const name = options.name || "<anonymous>";
          console.error(`Failed to initialize module ${name}`, err, options);
          if(throwInitErrors)
            throw err;
          return;
        }
      });
    }
    const whenReady = createModuleInitializer; // compat

    function waitForElement($parent, selector, { subtree = true } = {}) {
      const parentEl = $($parent)[0];
      return new Promise(resolve => {
        if(!parentEl)
          return;
        const nodeList = parentEl.querySelectorAll(selector);
        if(nodeList.length)
          return resolve($(nodeList));
        const obs = new MutationObserver(() => {
          const nodeList = parentEl.querySelectorAll(selector);
          if(nodeList.length) {
            obs.disconnect();
            resolve($(nodeList));
          }
        });
        obs.observe(parentEl, { childList: true, subtree: subtree });
      });
    }

    function createElement(tagName, attrs, children) {
      if(!common.isPlainObject(attrs)) {
        children = attrs;
        attrs = {};
      }

      let $el;
      if(tagName.charAt(0) === "<")
        $el = $(tagName);
      else {
        const parts = tagName.split(/([\.#]?[a-zA-Z0-9_:-]+)/).filter(Boolean);
        tagName = parts[0].match(/^\.|#/) ? "div" : parts.shift();
        $el = $(document.createElement(tagName))
        for(let part of parts) {
          if(part.charAt(0) === ".")
            $el.addClass(part.slice(1));
          else if(part.charAt(0) === "#")
            $el.prop("id", part.slice(1));
        }
      }
      if(attrs.class !== undefined) {
        $el.addClass(attrs.class);
        delete attrs.class;
      }
      $el.attr(attrs);

      if(Array.isArray(children))
        $el.append(children.flat(Infinity));
      else if(children instanceof $)
        $el.append(children);
      else if(children !== undefined)
        $el.text(children);

      return $el;
    }

    function createTextNode(text) {
      return $(document.createTextNode(text));
    }

    function signalNativeChange($el) {
      $($el).each(function() {
        shoptet.scripts.signalNativeEvent("change", this);
      });
    }

    function $each($coll, iteratee) {
      return $($coll).each((i, el) => iteratee($(el), i));
    }

    function $eachOneTime($coll, iteratee, key) {
      return $each($coll, ($el, i) => void (oneTime($el, key) && iteratee($el, i)));
    }

    function $eachOneTimeContents($coll, iteratee, key) {
      return $each($coll, ($el, i) => void (oneTimeContents($el, key) && iteratee($el, i)));
    }

    function $map($coll, iteratee, unwrapJq = true) {
      return $($coll).map((i, el) => {
        const res = iteratee($(el), i);
        return unwrapJq && (res instanceof $) ? res.get() : res;
      });
    }

    function $filter($coll, iteratee) {
      return $($coll).filter((i, el) => iteratee($(el), i));
    }

    return {
      trimHtml,
      getTextShallow,
      oneTime, oneTimeContents,
      whenReady, waitForElement,
      createModuleInitializer,
      createElement, createTextNode,
      signalNativeChange,
      $each, $map, $filter,
      $eachOneTime, $eachOneTimeContents,
    }
  })(), $h = dom.createElement, $t = dom.createTextNode;

  const ajax = (function() {
    function appendCacheBuster(url) {
      if(!url || (!config.noCache && !config.cacheBuster))
        return url;
      var buster = config.cacheBusterParam + "=" + encodeURIComponent(String(config.noCache ? Date.now() : config.cacheBuster));
      if(url.indexOf("?") !== -1)
        return url + "&" + buster;
      return url + "?" + buster;
    }

    function loadTextNoCache(url) {
      return common.promiseTry(() => $.ajax({
        method: "GET",
        url,
        dataType: "text"
      })).catch(function(err) {
        if(!err)
          throw new Error("Falsy rejection while loading '" + url + "'.");
        if(!(err instanceof Error)) {
          const newErr = new Error("Non-Error rejection while loading '" + url + "': " + [err.readyState, err.status, err.statusText].join(" "));
          newErr.orig = err;
          throw newErr;
        }
        throw err;
      });
    }

    const loadTextCached = common.memoize(["ajaxCache", helpers.getLocaleKey, common.identity], loadTextNoCache);

    const ajaxGetCached = loadTextCached; // compat

    function loadText(url, noCache) {
      return Promise.resolve(noCache ? loadTextNoCache(url) : loadTextCached(url))
    }

    async function loadFragment(url, noCache) {
      return $(await loadText(url, noCache), shoptet.common.createDocumentFromString(""));
    }

    async function loadDocument(url, noCache) {
      return $(shoptet.common.createDocumentFromString(await loadText(url, noCache)));
    }

    function load(urls, loader, noCache) {
      if(!loader)
        loader = loadDocument;

      if(typeof urls === "string")
        return loader(urls);

      if(Array.isArray(urls)) { // deduplicate urls
        let promises = {};
        return Promise.all(urls.map(function(url) {
          if(!promises[url])
            promises[url] = loader(url, noCache);
          return promises[url];
        }));
      }

      var keys = Object.keys(urls),
        values = keys.map(function(key) {
          return urls[key];
        });

      return load(values, loader).then(function(payloads) {
        var result = {};
        for(var i = 0; i < keys.length; i++)
          result[keys[i]] = payloads[i];
        return result;
      });
    }

    function loadSnippets(urls, loader, noCache) {
      if(!loader)
        loader = loadFragment;

      return load(urls, function(url) {
        return loader(config.snippetPath + appendCacheBuster(url), noCache);
      });
    }

    function withSnippets(urls, callback) {
      return function() {
        var args = [].slice.call(arguments), context = this;
        loadSnippets(urls).then(function(snippets) {
          args.unshift(snippets);
          callback.apply(context, args);
        });
      };
    }

    function restoreShoptetCookies() {
      const language = getShoptetDataLayer().language;
      const currencyCode = getShoptetDataLayer().currency;
      document.cookie = "language=" + language + "; max-age=31536000; path=/; secure";
      document.cookie = "currencyCode=" + currencyCode + "; max-age=31536000; path=/; secure";
    }

    return {
      appendCacheBuster,
      ajaxGetCached,
      loadText, loadFragment, loadDocument,
      load,
      loadSnippets, withSnippets,
      restoreShoptetCookies,
    };
  })();

  const hooks = (function() {
    function hookFn(nameOrFn, callback) {
      var origFn = typeof nameOrFn === "string" ? common.getProperty(window, nameOrFn) : nameOrFn;
      if(typeof origFn !== "function") {
        console.error("Failed to hook " + nameOrFn + " (not a function)");
        return;
      }

      function patchedFn() {
        let calledOrigFn = false;
        try {
          return callback(function() {
            calledOrigFn = true;
            return origFn.apply(this, arguments);
          }, arguments, this);
        } catch(err) {
          if(!calledOrigFn) {
            console.error("Patched callback for", nameOrFn, "has thrown an exception before calling origFn: ", err);
            return origFn.apply(this, arguments);
          }
          throw err;
        }
      };
      patchedFn.origFn = origFn;

      if(typeof nameOrFn === "string")
        common.setProperty(window, nameOrFn, patchedFn);
      return patchedFn;
    }

    function hookAfterAjaxDone(url, callback) {
      var urlMatches;
      if(typeof url === "function")
        urlMatches = url;
      else if(url instanceof RegExp)
        urlMatches = function(_url) {
          return url.test(_url);
        };
      else
        urlMatches = function(_url) {
          return url === _url;
        };

      hookFn("$.ajax", function(oldAjax, args, context) {
        var options = args[0],
          ajaxResult = oldAjax.apply(context, args);
        if(urlMatches(options.url, options)) {
          ajaxResult.done = hookFn(ajaxResult.done, function(oldDone, args, context) {
            args = [].slice.call(args);
            args.push(function() {
              try {
                return callback.apply(this, arguments);
              } catch(err) {
                console.error("Ajax callback has thrown an exception:", err);
              }
            });
            return oldDone.apply(context, args);
          });
        }
        return ajaxResult;
      });
    }

    function hookAfterDomLoad(callback, native) {
      const events = ["ShoptetDOMContentLoaded", "ShoptetDOMContentChanged", "TDOMContentLoaded"];
      function handler(e) {
        try {
          callback.call(e ? e.target : null);
        } catch(err) {
          console.error("Dom load callback has thrown an exception:", err);
        }
      }
      for(let event of events)
        document.addEventListener(event, handler);
      if(native)
        $(() => handler());
    }

    function signalDomLoad(event, element) {
      var globalEvent = "TDOMContentLoaded";
      if(!event) {
        event = globalEvent;
        globalEvent = null;
      }
      shoptet.scripts.signal(event, element, null, globalEvent);
    }

    function hookAfterWindowResize(callback, debounceTime = 250) {
      const $w = $(window);
      function boundCallback() {
        try {
          callback($w.width());
        } catch(err) {
          console.error("Resize callback has thrown an exception:", err);
        }
      }
      $w.on("resize", debounceTime > 0 ? tb.common.debounce(boundCallback, debounceTime) : boundCallback);
      boundCallback();
    }

    function respond(query, onMatch, onUnmatch) {
      const media = matchMedia(query);
      let onUnmatch2, onMatch2, matches = null;
      function safeCall(f) {
        return typeof f === "function" ? f() : undefined;
      }
      function onChange(e) {
        const _matches = e.matches;
        if(matches === _matches)
          return;
        matches = _matches;
        if(matches) {
          safeCall(onMatch2), onMatch2 = null;
          onUnmatch2 = safeCall(onMatch);
        } else {
          safeCall(onUnmatch2), onUnmatch2 = null;
          onMatch2 = safeCall(onUnmatch);
        }
      }
      media.addEventListener("change", onChange);
      onChange(media);
    }

    /** @deprecated */
    function bindEvents(eventNames, callback, now, $el) {
      $el = $($el || document);
      if(!Array.isArray(eventNames))
        eventNames = [eventNames];
      for(let name of eventNames) {
        if(name === "ready")
          $(callback);
        else
          $el[0].addEventListener(name, callback);
      }
      if(now)
        callback();
    }

    return {
      hookFn,
      hookAfterAjaxDone,
      hookAfterDomLoad,
      signalDomLoad,
      hookAfterWindowResize,
      respond,
      bindEvents,
    };
  })();

  const sh = (function() {
    function splitVariantCode(code, asObject) {
      var parts = code.split("-"),
        res = asObject ? {} : [];
      for(var i = 0; i < parts.length; i += 2) {
        var pair = [
          common.parseNumber(parts[i]),
          common.parseNumber(parts[i + 1])
        ];
        if(asObject)
          res[pair[0]] = pair[1];
        else
          res.push(pair);
      }
      return res;
    }

    function joinVariantCode(pairs) {
      let tempVariantCode = [];
      if(Array.isArray(pairs)) {
        for(let p of pairs)
          tempVariantCode.push(String(p[0]) + "-" + String(p[1]))
      } else {
        for(let key in pairs)
          tempVariantCode.push(String(key) + "-" + String(pairs[key]));
      }
      tempVariantCode.sort();
      return tempVariantCode.join("-");
    }

    function extractVariantCode($el) {
      var className;
      if($el instanceof $)
        className = $el.attr("class") || "";
      else
        className = $el;
      for(let c of className.split(" ")) {
        let m = c.trim().match(/^([0-9-]+)$/);
        if(m)
          return m[1];
      }
      return null;
    }

    function getNecessaryVariantData(necessaryVariantData, asObject = false) {
      if(necessaryVariantData instanceof $) {
        const script = necessaryVariantData.find(".detail-parameters,.p-variants-block").find("script").html();
        const dataSerialized = script?.match(/shoptet.variantsSplit.necessaryVariantData = (.+);/)?.[1];
        necessaryVariantData = dataSerialized ? JSON.parse(dataSerialized) : {};
      } else if(!common.isPlainObject(necessaryVariantData)) {
        asObject = asObject || Boolean(necessaryVariantData);
        necessaryVariantData = null;
      }

      const variants = necessaryVariantData || shoptet.variantsSplit.necessaryVariantData || {};
      for(let code in variants) {
        const variant = variants[code];
        if(variant.tb_code)
          continue;

        variant.tb_code = code;
        variant.tb_parameterValues = splitVariantCode(code, false);
        variant.tb_parameterValuesObj = splitVariantCode(code, true);
        variant.tb_price = common.parsePrice(variant.price);
        variant.tb_standardPrice = common.parsePrice(variant.standardPrice);
      }
      return asObject ? variants : Object.values(variants);
    }

    function getSelectedParameterValues($form, inclMissing = false) {
      if(!$form)
        $form = $(".p-detail");

      const parameterValues = {};
      $form.find('.variant-list .hidden-split-parameter, .variant-list .split-parameter').each(function() {
        const parameterId = $(this).data("parameterId");
        const valueId = $(this).find('input:checked,option:selected').val();
        if(valueId !== '')
          parameterValues[parameterId] = tb.common.parseNumber(valueId);
        else if(inclMissing)
          parameterValues[parameterId] = null;
      });
      return parameterValues;
    }

    function convertImageUrl(url, size = "orig") {
      if(!["detail", "thumb", "related", "big", "orig"].includes(size))
        throw new Error("Invalid image size: " + size);
      return url.replace(/\/(detail|thumb|related|orig|big)\//, "/" + size + "/");
    }

    function getDescriptiveParameters($detail, asObject = false) {
      if(!$detail)
        $detail = $(".p-detail");
      const params = [];
      dom.$each($detail.find(".extended-description .detail-parameters tr"), $tr => {
        const name = dom.getTextShallow($tr.find(".row-header-label")).trim();
        if(name)
          params[name] = { $tr, name, value: $tr.find("td").text().trim(), };
      });
      return asObject ? params : Object.values(params);
    }

    return {
      splitVariantCode, joinVariantCode, extractVariantCode,
      getNecessaryVariantData, getSelectedParameterValues, getDescriptiveParameters,
      convertImageUrl,
    };
  })();

  const ui = (function() {
    function wrapColorboxHtml($elOrHtml) {
      if(typeof $elOrHtml === "string")
        return shoptet.content.colorboxHeader + $elOrHtml + shoptet.content.colorboxFooter;
      const wrapHtml = shoptet.content.colorboxHeader + shoptet.content.colorboxFooter;
      return wrapHtml ? $(wrapHtml).html($elOrHtml) : $($elOrHtml);
    }

    async function loadAndOpenModal(url, selectorOrTransformer, optionsOrSize = {}) {
      const transformer = typeof selectorOrTransformer === "string" ? $page => $page.find(selectorOrTransformer) : selectorOrTransformer;
      const options = typeof optionsOrSize === "string" ? { size: optionsOrSize } : (optionsOrSize || {});

      const size = (!options.size && options.size !== null) ? "lg" : options.size;
      delete options.size;

      if(size !== null) {
        const sizeSuffix = size.slice(0, 1).toUpperCase() + size.slice(1).toLowerCase();
        if(options.width === undefined)
          options.width = shoptet.modal.config["width" + sizeSuffix];
        options.className = `${shoptet.modal.config["class" + sizeSuffix]} ${options.className || ""}`;
      }

      const $page = await ajax.loadDocument(url);
      const $content = $(transformer($page));
      if(!$content.length)
        throw new Error(`Element not found (url: ${url})`);

      return new Promise(resolve => {
        shoptet.modal.open({
          ...options,
          html: wrapColorboxHtml($content),
          onComplete() {
            if(options.onComplete?.() !== false) {
              $(".colorbox-html-content img").unveil();
              $("body").removeClass(shoptet.config.bodyClasses);
              hideSpinner();
              setTimeout(() => {
                shoptet.modal.shoptetResize();
              }, 1);
              tb.hooks.signalDomLoad();
            }
            resolve();
          },
        });
      });
    }

    function responsiveSlick(breakpoint, $el, options) {
      $el = $($el).filter(function() {
        return dom.oneTime(this, "responsiveSlick");
      });
      if(typeof breakpoint !== "function") {
        let maxWidth = breakpoint;
        breakpoint = function(width) {
          return width <= maxWidth;
        };
      }

      var oldVisible = null;
      function resizeHandler() {
        var visible = !!breakpoint($(window).width());
        if(visible === oldVisible)
          return;
        $el = $el.filter(function() {
          return this.isConnected;
        });
        if(!$el.length) {
          $(window).off("resize", resizeHandler);
          return;
        }
        try {
          if(visible)
            $el.slick(options);
          else if(oldVisible)
            $el.slick("destroy");
        } finally {
          oldVisible = visible;
        }
      }
      $(window).resize(common.debounce(resizeHandler, 250));
      resizeHandler();
    }

    const tabletSlick = responsiveSlick.bind(null, config.tabletSlickBreakpoint);
    const mobileSlick = responsiveSlick.bind(null, config.mobileSlickBreakpoint);

    return {
      wrapColorboxHtml,
      loadAndOpenModal,
      responsiveSlick,
      tabletSlick, mobileSlick,
    };
  })();

  class JsonStorage {
    constructor(key, defaultFactory = (() => ({})), backend = window.sessionStorage) {
      if(!common.isString(key))
        throw new Error("Storage key must be a string.");
      this.key = key;
      this.defaultFactory = defaultFactory;
      this.backend = backend;
    }

    static local(key, defaultFactory = (() => ({}))) {
      return new JsonStorage(key, defaultFactory, window.localStorage);
    }

    static session(key, defaultFactory = (() => ({}))) {
      return new JsonStorage(key, defaultFactory, window.sessionStorage);
    }

    get() {
      const rawValue = this.backend.getItem(this.key);
      return rawValue === null ? this.defaultFactory() : JSON.parse(rawValue);
    }

    set(obj) {
      this.backend.setItem(this.key, JSON.stringify(obj));
    }

    clear() {
      this.backend.removeItem(this.key);
    }

    updateAndGet(f) {
      const obj = f(this.get());
      this.set(obj);
      return obj;
    }

    /** @deprecated */
    getAndUpdate(f) {
      return this.updateAndGet(f);
    }
  }

  const toolbox = {
    config,
    common,
    helpers,
    dom, $h, $t,
    ajax,
    hooks,
    sh,
    ui,
    JsonStorage,
  };

  if(window.toolbox)
    console.error("toolbox is already loaded, original:", window.toolbox);

  window.toolbox = window.tb = toolbox;
  return toolbox;

})();
